//ebitdaUtils.ts
import { CategoryOption, EBITDARole } from '../types';

// Detect EBITDA role from category name and type
export const detectEBITDARole = (category: CategoryOption): EBITDARole => {
  const nameLower = category.label.toLowerCase();
  
  // Interest expense detection
  if (category.type === 'interest-expense' || 
     /^interest\s+expense|interest.*expense\s*\(income\)/.test(nameLower)) {
    return 'interest-expense';
  }
  
  // Income tax detection
  if (category.type === 'income-tax-expense' || 
     /income\s+tax\s+expense|tax\s+expense|income\s+taxes/.test(nameLower)) {
    return 'income-tax-expense';
  }
  
  // Depreciation detection
  if (/^depreciation$|^depreciation\s+expense|property\s+depreciation|depreciation\s+of\s+|fixed\s+asset\s+depreciation/.test(nameLower)) {
    return 'depreciation';
  }
  
  // Amortization detection
  if (/^amortization$|^amortization\s+expense|intangible\s+amortization|amortization\s+of\s+/.test(nameLower)) {
    return 'amortization';
  }
  
  return null;
};

// Get the label for display when showing the EBITDA role
export const getEBITDADisplayLabel = (role: EBITDARole): string => {
  switch (role) {
    case 'interest-expense':
      return 'Interest Expense';
    case 'income-tax-expense':
      return 'Income Tax';
    case 'depreciation':
      return 'Depreciation';
    case 'amortization':
      return 'Amortization';
    default:
      return '';
  }
};

// Get CSS class for styling the EBITDA role tags
export const getEBITDARoleColorClass = (role: EBITDARole): string => {
  switch (role) {
    case 'interest-expense':
      return 'bg-purple-100 text-purple-800';
    case 'income-tax-expense':
      return 'bg-pink-100 text-pink-800';
    case 'depreciation':
      return 'bg-indigo-100 text-indigo-800';
    case 'amortization':
      return 'bg-violet-100 text-violet-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

// Check if a role is part of EBITDA
export const isEBITDAComponent = (role: EBITDARole): boolean => {
  return role !== null;
};

// Get array of all categories with a specific EBITDA role from template
export const getCategoriesByEBITDARole = (
  templateCategories: CategoryOption[],
  role: EBITDARole
): CategoryOption[] => {
  if (!templateCategories) return [];
  return templateCategories.filter(category => category.ebitdaRole === role);
};
